export type fieldNameType =
  | "barkodas"
  | "objektas"
  | "serija"
  | "lokacija"
  | "lokacija2"
  | "kiekis"
  | "papildomi"
  | "objektas2"
  | "serija2"
  | "galiojimodata"
  | "galiojimodata2";

const fieldNames: { [key: string]: fieldNameType } = {
  BARCODE: "barkodas",
  QUANTITY: "kiekis",
  LOT: "serija",
  LOCATION: "lokacija",
  LOCATION2: "lokacija2",
  OBJECT: "objektas",
  EXTRA: "papildomi",
  LOT2: "serija2",
  OBJECT2: "objektas2",
  EXPDATE: "galiojimodata",
  EXPDATE2: "galiojimodata2",
};

export default fieldNames;
